export default {
    CALL_CENTER_WORKED_TIME: ['10:00', '17:00'],
};
